export default __webpack_public_path__ + "static/media/headerBG02.86257ff9.png";